import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { NOTIFICATION_TYPES } from './settingsData';

function Toggle({ checked, onChange, disabled }) {
  return (
    <button
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors disabled:cursor-not-allowed ${
        disabled ? 'bg-slate-100' : checked ? 'bg-[#3b4c4c]' : 'bg-slate-200'
      }`}
    >
      <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform ${
        checked ? 'translate-x-4.5' : 'translate-x-0.5'
      }`} style={{ transform: checked ? 'translateX(18px)' : 'translateX(2px)' }} />
    </button>
  );
}

export default function NotificationsSection({ showToast }) {
  const [channels, setChannels] = useState(
    NOTIFICATION_TYPES?.reduce((acc, t) => ({
      ...acc,
      [t?.id]: { inApp: true, email: t?.id !== 'system', sms: false, push: false },
    }), {})
  );
  const [priorities, setPriorities] = useState(
    NOTIFICATION_TYPES?.reduce((acc, t) => ({ ...acc, [t?.id]: 'All' }), {})
  );
  const [frequency, setFrequency] = useState('Daily digest');
  const [digestTime, setDigestTime] = useState('08:00');
  const [notifEmail, setNotifEmail] = useState('sarah.mitchell@seeddrive.demo');
  const [dndEnabled, setDndEnabled] = useState(false);
  const [dndFrom, setDndFrom] = useState('20:00');
  const [dndTo, setDndTo] = useState('08:00');
  const [dndDays, setDndDays] = useState(['Mon', 'Tue', 'Wed', 'Thu', 'Fri']);

  const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  const toggleChannel = (typeId, channel) => {
    setChannels(prev => ({ ...prev, [typeId]: { ...prev?.[typeId], [channel]: !prev?.[typeId]?.[channel] } }));
  };

  const toggleDay = (day) => {
    setDndDays(prev => prev?.includes(day) ? prev?.filter(d => d !== day) : [...prev, day]);
  };

  return (
    <div>
      {/* Delivery Channels */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm mb-6">
        <div className="px-6 py-4 border-b border-slate-100">
          <h3 className="text-base font-semibold text-slate-900">Delivery Channels</h3>
          <p className="text-sm text-slate-500">Configure how you receive each type of notification.</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-100">
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wide">Notification Type</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wide">In-App</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wide">Email Digest</th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  <span className="flex items-center justify-center gap-1">SMS <span className="text-slate-300 font-normal normal-case">soon</span></span>
                </th>
                <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  <span className="flex items-center justify-center gap-1">Push <span className="text-slate-300 font-normal normal-case">soon</span></span>
                </th>
              </tr>
            </thead>
            <tbody>
              {NOTIFICATION_TYPES?.map(type => (
                <tr key={type?.id} className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-2.5">
                      <Icon name={type?.icon} size={15} color="#64748b" />
                      <span className="text-sm font-medium text-slate-700">{type?.label}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <Toggle checked={channels?.[type?.id]?.inApp} onChange={() => toggleChannel(type?.id, 'inApp')} />
                  </td>
                  <td className="px-4 py-3 text-center">
                    <Toggle checked={channels?.[type?.id]?.email} onChange={() => toggleChannel(type?.id, 'email')} />
                  </td>
                  <td className="px-4 py-3 text-center">
                    <Toggle onChange={() => {}} disabled />
                  </td>
                  <td className="px-4 py-3 text-center">
                    <Toggle onChange={() => {}} disabled />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Email Digest Settings */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 mb-6">
        <h3 className="text-base font-semibold text-slate-900 mb-1">Email Digest Settings</h3>
        <p className="text-sm text-slate-500 mb-5">Configure when and how you receive email digests.</p>
        <div className="border-t border-slate-100 pt-5 grid grid-cols-1 sm:grid-cols-3 gap-4 mb-5">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Frequency</label>
            <select value={frequency} onChange={e => setFrequency(e?.target?.value)} className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3b4c4c]/30">
              <option>Immediate</option>
              <option>Daily digest</option>
              <option>Weekly digest</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Send Time</label>
            <input type="time" value={digestTime} onChange={e => setDigestTime(e?.target?.value)} className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3b4c4c]/30" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Notification Email</label>
            <input type="email" value={notifEmail} onChange={e => setNotifEmail(e?.target?.value)} className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3b4c4c]/30" />
          </div>
        </div>
        <div className="flex justify-end">
          <button onClick={() => showToast('Notification preferences saved')} className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#3b4c4c] hover:bg-[#162d4a] transition-colors shadow-sm">
            <Icon name="Save" size={15} />
            Save
          </button>
        </div>
      </div>
      {/* Priority Thresholds */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm mb-6">
        <div className="px-6 py-4 border-b border-slate-100">
          <h3 className="text-base font-semibold text-slate-900">Priority Thresholds</h3>
          <p className="text-sm text-slate-500">Set the minimum priority level for each notification type.</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-100">
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wide">Type</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wide">Minimum Priority</th>
              </tr>
            </thead>
            <tbody>
              {NOTIFICATION_TYPES?.map(type => (
                <tr key={type?.id} className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-3">
                    <div className="flex items-center gap-2.5">
                      <Icon name={type?.icon} size={15} color="#64748b" />
                      <span className="text-sm font-medium text-slate-700">{type?.label}</span>
                    </div>
                  </td>
                  <td className="px-6 py-3">
                    <select
                      value={priorities?.[type?.id]}
                      onChange={e => setPriorities(prev => ({ ...prev, [type?.id]: e?.target?.value }))}
                      className="px-3 py-1.5 border border-slate-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3b4c4c]/30"
                    >
                      <option>All</option>
                      <option>Medium and above</option>
                      <option>High only</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Do Not Disturb */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="text-base font-semibold text-slate-900">Do Not Disturb</h3>
            <p className="text-sm text-slate-500">Suppress non-critical notifications during specified hours.</p>
          </div>
          <Toggle checked={dndEnabled} onChange={setDndEnabled} />
        </div>
        {dndEnabled && (
          <div className="border-t border-slate-100 pt-5">
            <div className="grid grid-cols-2 gap-4 mb-5">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">From</label>
                <input type="time" value={dndFrom} onChange={e => setDndFrom(e?.target?.value)} className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3b4c4c]/30" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">To</label>
                <input type="time" value={dndTo} onChange={e => setDndTo(e?.target?.value)} className="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3b4c4c]/30" />
              </div>
            </div>
            <div className="mb-5">
              <label className="block text-sm font-medium text-slate-700 mb-2">Active Days</label>
              <div className="flex flex-wrap gap-2">
                {DAYS?.map(day => (
                  <button
                    key={day}
                    onClick={() => toggleDay(day)}
                    className={`px-3 py-1.5 rounded-xl text-xs font-semibold transition-colors ${
                      dndDays?.includes(day)
                        ? 'bg-[#3b4c4c] text-white'
                        : 'border border-slate-200 text-slate-600 hover:bg-slate-50'
                    }`}
                  >
                    {day}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex items-start gap-2 p-3 bg-[rgba(59,76,76,0.07)] rounded-xl border border-blue-100 mb-5">
              <Icon name="Info" size={14} color="#3b82f6" className="mt-0.5 flex-shrink-0" />
              <p className="text-xs text-blue-700">During DND, only High priority Capital Call notifications will override.</p>
            </div>
          </div>
        )}
        <div className="flex justify-end">
          <button onClick={() => showToast('Do Not Disturb settings saved')} className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#3b4c4c] hover:bg-[#162d4a] transition-colors shadow-sm">
            <Icon name="Save" size={15} />
            Save DND Settings
          </button>
        </div>
      </div>
    </div>
  );
}
